import { ReactNode, useState } from 'react';

export const Toggle = ({
  children,
}: {
  children: (isOpened: boolean, toggle: () => void) => ReactNode;
}) => {
  const [isOpened, setIsOpened] = useState(false);

  const toggle = () => setIsOpened((prev) => !prev);

  return <>{children(isOpened, toggle)}</>;
};
